import { v4 as uuidv4 } from "uuid";

export interface CategoryInterface {
  id: string;
  name: string;
  description: string;
}

class Category implements CategoryInterface {
  readonly id: string;
  readonly name: string;
  readonly description: string;

  constructor(category?: Partial<CategoryInterface>) {
    this.id = category?.id || uuidv4();
    this.name = category?.name || "";
    this.description = category?.description || "";
  }

  toJSON(): any {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
    };
  }

  static fromJSON(data: any): Category {
    return new Category({
      id: data.id,
      name: data.name,
      description: data.description,
    });
  }

  getName(): string {
    return this.name;
  }

  setName(name: string): Category {
    return new Category({
      ...this,
      name: name,
    });
  }

  getDescription(): string {
    return this.description;
  }

  setDescription(description: string): Category {
    return new Category({
      ...this,
      description: description,
    });
  }
}

export default Category;
